import { render } from "./situationImpaye.vue?vue&type=template&id=74a873c5"
import script from "./situationImpaye.vue?vue&type=script&lang=js"
export * from "./situationImpaye.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__